import React, { Component } from 'react'
import {observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider  from 'react-bootstrap-table2-toolkit';
import {Button, Col, Container, Row} from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../../comum/components/LoadingImage";
import Footer from "../../../comum/components/Footer";
import FooterOptions from "../../../comum/components/FooterOptions";
import ImportacaoCard from "./ImportacaoCard";
import {IconeCarregar, IconeSetaDireitaMenor, IconeSoma} from "../../../comum/components/Icones";
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";

@observer
export class TabelaImportacao extends Component {

    constructor(props){
        super(props)

        this.controller = this.props.controller;

        this.addColDetalhes();

        window.addEventListener('scroll', HeaderTableFixed);
    }

    handleAbrirDetalhes = (row) => {
        this.controller.abrirDetalhes(row, this.props.mudaTitulo());
    };

    handleAdicionarNovoDi = (row) => {
        this.controller.abrirModalNovaDi(row, this.props.mudaTitulo());
    };

    addColDetalhes = () => {
        if(process.env.ssa) {
            this.controller.colunas.push({
                dataField: 'novoDI',
                isDummyField: true,
                text: 'Incluir nova DI',
                formatter: (cell, row) =>
                    row.TipoProtocolo === "DA" && row.ProtocoloIdPai === null
                        ? <Button outline className="collapseItem rounded" onClick={ () => this.handleAdicionarNovoDi(row)} >
                            <IconeSoma tamanho="sm" />
                        </Button>
                        : ""
            });
        }
        this.controller.colunas.push({
            dataField: 'detalhes',
            isDummyField: true,
            text: 'Detalhes',
            formatter: (cell, row) => {
                return <Button outline className="collapseItem rounded" onClick={ () => this.handleAbrirDetalhes(row) } >
                    <IconeSetaDireitaMenor tamanho="sm" />
                </Button>
            }
        });
    };

    render() {
        return (
            <Container fluid className={ this.controller.detalhesAtivo ? "tabela-container escondido" : "tabela-container" }>
                { this.controller.loading || this.controller.carregandoDetalhes ? <LoadingImage/>

                    : <React.Fragment>
                        { (!this.controller.importacoes.length>0)
                            ? <Row>
                                <Col xs={12}>
                                    <span className="mensagem-filtrar">
                                        {this.controller.tableMessage}
                                    </span>
                                </Col>
                            </Row>
                            :

                            <InfiniteScroll
                                dataLength = {this.controller.items.length}
                                next = {() => this.controller.loadNextTurn()}
                                loadder = {<span>Carregando....</span>}
                                hasMore = {this.controller.hasMore}
                                loader = {<LoadingImage/>}
                            >
                                <ToolkitProvider
                                    keyField="ProtocoloId"
                                    data={[...this.controller.items]}
                                    columns={[...this.controller.colunas]} >
                                    {props => (
                                        <div>
                                            { window.innerWidth > 991
                                                ? 
                                                <div id="tableHeaderFixed" className="tabela-overflow">
                                                    <BootstrapTable bootstrap4
                                                                  striped
                                                                  bordered={false}
                                                                  noDataIndication={() => this.controller.noData}
                                                                  classes="tabela tabela-layout cabotagem"
                                                                  {...props.baseProps} />
                                                </div>
                                                : <Row>
                                                    {this.controller.items.map((card, x) => (
                                                        <ImportacaoCard
                                                            controller={this.controller}
                                                            key={x}
                                                            data={card}
                                                            id={x}
                                                            colunas={[...this.controller.colunas]}
                                                            titulo={"NavioNome"}
                                                            subtitulo={"Viagem"}

                                                        />
                                                    )) }
                                                </Row>
                                            }
                                        </div>)
                                    }
                                </ToolkitProvider>
                            </InfiniteScroll> }
                    </React.Fragment>
                }

                <Footer>
                    <FooterOptions>
                        <div>
                            {/*<IconButton icon="file-pdf" text="Baixar PDF" size="md"*/}
                            {/*    disabled={this.controller.importacoes}*/}
                            {/*    onClick={() => makePDF(*/}
                            {/*        this.controller.importacoes,*/}
                            {/*        pdfData.map(elem => elem.dataField),*/}
                            {/*        pdfData.map(elem => elem.text),*/}
                            {/*        pdfDataTime.map(elem => elem.dataField),*/}
                            {/*        [{input: 'NavioNome', append: 'Viagem'}],*/}
                            {/*        true*/}
                            {/*    )}*/}
                            {/*/>*/}
                        </div>
                        <div>
                            {/*<ExportarExcelProgramacaoNavios controller={ this.naviosStore }/>*/}
                        </div>
                    </FooterOptions>
                </Footer>

            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/TabelaImportacao.js